import { Component, Input, OnDestroy } from '@angular/core';
import { ProductNames, TimeSpentPipe } from '@mynexus/mynexus-ui-lib';
import { ServiceLineCountdown } from '@shared/model';
import { pendingServiceLineIdentification } from '@shared/utility';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'service-line-countdown',
    templateUrl: './service-line-countdown.component.html',
    styleUrls: ['./service-line-countdown.component.scss'],
    standalone: false
})

export class ServiceLineCountdownComponent implements OnDestroy {
  @Input() set data(value: ServiceLineCountdown) {
    this.getAnticipatedTime(value);
  }

  @Input() product: string;

  anticipatedTime: string;
  countdownColor: string;
  anticipatedTimeInterval = null;

  constructor(
    private timeSpentPipe: TimeSpentPipe,
  ) { }

  ngOnDestroy(): void {
    clearInterval(this.anticipatedTimeInterval);
  }

  private getAnticipatedTime(serviceLine: ServiceLineCountdown): void {
    clearInterval(this.anticipatedTimeInterval);

    if (serviceLine?.date) {
      const endDate = new Date(serviceLine.date).getTime();

      this.anticipatedTimeInterval = setInterval(() => {
        const { color, remainingTime } = pendingServiceLineIdentification(endDate, serviceLine?.urgency);

        this.anticipatedTime = this.timeSpentPipe.transform(serviceLine.date, '[d] days + [h]h:[m]m:[s]s', null, true, true);

        if (this.product === ProductNames.HomeHealth) {
          this.countdownColor = color;
        }

        if (remainingTime < 0) {
          clearInterval(this.anticipatedTimeInterval);
        }
      }, 1000);
    } else {
      this.anticipatedTime = null;
      this.countdownColor = null;
    }
  }
}
